import React from 'react';
import { Typography } from '@mui/material';
import { titleTypographyStyles } from '../styles/NavBarStyles';

export const NavBarTitle = ({ title }) => {
  return (
    <Typography variant="h6" component="div" sx={titleTypographyStyles}>
      {title}
    </Typography>
  );
};
